// extracted by mini-css-extract-plugin
export default {"rating":"iJ-z","numberOfStars":"jJ-z","count":"kJ-z","barGraphSpacing":"lJ-z","barGraph":"mJ-z"};